import CityPageTemplate from "../city-template/CityPageTemplate";
import { odessaConfig } from "./data";

export default function OdessaPage() {
  return <CityPageTemplate config={odessaConfig} />;
}